import { z } from 'zod';
import { DIFFERENT_VARIABLES_BRIDGE_NAME, OUTGOING_BRIDGE_KIND, SAME_VARIABLE_BRIDGE_NAME } from '../constnats/outgoingBridge';

export const sameVariableBridgeNameSchema = z.nativeEnum(SAME_VARIABLE_BRIDGE_NAME);

export const outgoingBridgeSchema = z.object({
    endId: z.string().min(1),
    name: z.string().trim().min(1, 'Select a bridge name.'),
});

export const outgoingBridgesSchema = z.object({
    [OUTGOING_BRIDGE_KIND.SAME_VARIABLE]: z.array(outgoingBridgeSchema),
    [OUTGOING_BRIDGE_KIND.DIFFERENT_VARIABLES]: z.array(outgoingBridgeSchema),
}).superRefine((bridges, context) => {
    const sharedName = bridges.sameVariable[0]?.name;
    bridges.sameVariable.forEach((bridge, index) => {
        if (!bridge.name) {
            return;
        }
        if (!sameVariableBridgeNameSchema.safeParse(bridge.name).success) {
            context.addIssue({
                code: z.ZodIssueCode.custom,
                message: 'Select a bridge name from the available options.',
                path: [OUTGOING_BRIDGE_KIND.SAME_VARIABLE, index, 'name'],
            });
        } else if (bridge.name !== sharedName) {
            context.addIssue({
                code: z.ZodIssueCode.custom,
                message: 'Use the same name for every Same Variable bridge.',
                path: [OUTGOING_BRIDGE_KIND.SAME_VARIABLE, index, 'name'],
            });
        }
    });
    bridges.differentVariables.forEach((bridge, index) => {
        if (bridge.name && bridge.name !== DIFFERENT_VARIABLES_BRIDGE_NAME) {
            context.addIssue({
                code: z.ZodIssueCode.custom,
                message: 'Different Variables bridges must be named x.',
                path: [OUTGOING_BRIDGE_KIND.DIFFERENT_VARIABLES, index, 'name'],
            });
        }
    });
    const bridgeEndDescriptorIds = new Set<string>();
    for (const kind of Object.values(OUTGOING_BRIDGE_KIND)) {
        bridges[kind].forEach((bridge, index) => {
            if (bridgeEndDescriptorIds.has(bridge.endId)) {
                context.addIssue({
                    code: z.ZodIssueCode.custom,
                    message: 'Select a descriptor as a bridge end only once across both variable collections.',
                    path: [kind, index, 'endId'],
                });
            }
            bridgeEndDescriptorIds.add(bridge.endId);
        });
    }
});

export type OutgoingBridgeType = z.infer<typeof outgoingBridgeSchema>;
export type OutgoingBridgesType = z.infer<typeof outgoingBridgesSchema>;
export type OutgoingBridgeKindType = keyof OutgoingBridgesType;
